/**
 * Empty state component for notifications page.
 * Shown when user has no notifications.
 */
export function EmptyNotifications() {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <p className="text-lg text-muted text-center">You're all caught up! 🎉</p>
      <p className="text-sm text-disabled mt-2 text-center">
        When someone interacts with your trips, you'll see it here.
      </p>
    </div>
  );
}
